module.exports = __webpack_public_path__ + "img/avbuilder_trashphoto.b0744dc1.svg";